export type StickerFairyPromptMode = 'sticker' | 'art';

const STICKER_PROMPT_SUFFIX =
  'Create the requested sticker art as a centered sticker/icon asset on a pure solid white (#FFFFFF) background.';

export function normalizeStickerFairyPrompt(input: string): string {
  const trimmed = input.trim();

  // Gemini image generation has been flaky when prompts include punctuation
  // sequences like `!.` or `..` (it returns no image). Normalize those cases.
  return trimmed
    .replace(/([!?])\.+/g, '$1')
    .replace(/\.{2,}/g, '.')
    .replace(/\s{2,}/g, ' ');
}

export function buildStickerFairyPrompt(
  input: string,
  mode: StickerFairyPromptMode = 'sticker'
): string {
  const normalized = normalizeStickerFairyPrompt(input);
  if (!normalized) {
    return mode === 'sticker' ? STICKER_PROMPT_SUFFIX : '';
  }

  if (mode === 'art') {
    return normalized;
  }

  const needsSeparator = /[.!?]$/.test(normalized) ? ' ' : '. ';
  return `${normalized}${needsSeparator}${STICKER_PROMPT_SUFFIX}`;
}
